import { InspectionTypeEnum } from '@authority-labs/enums';

export function getInspectionTypeTextBankKey(
  inspectionType: InspectionTypeEnum
): string {
  const type =
    inspectionType === InspectionTypeEnum.InspectionDesign ||
    inspectionType === InspectionTypeEnum.InspectionInstallation ||
    inspectionType === InspectionTypeEnum.InspectionDesignAndInstallation
      ? InspectionTypeEnum.InspectionDesignAndInstallation
      : inspectionType;

  return type || 'inspection-standard';
}
